export const UserValidationConfiguration = {
    pinMaxLength: 10,
    pinMinLength: 4
};
